const Forbidden = () => {
  return (
    <>
      <div className="error-container">
        <div className="text-center mt-5">
          <h2 className="text-warning">Forbidden</h2>
          <h3>
            <i className="fas fa-exclamation-triangle text-warning" />{" "}
            Permission has not been granted for this resource.
          </h3>
        </div>
      </div>
    </>
  );
};

export default Forbidden;
